import { createContext, useContext } from 'react';
import type {
  AuctionDataRefClick,
  PromoteClick,
  ReviewClick,
} from '../../components/Listing/types/ListingActionHandlers';
import type { SetModalContent } from '../../pages/Listings/Modals';

type ListingActionHandlers = {
  promote: PromoteClick;
  review: ReviewClick;
  auctionData: AuctionDataRefClick;
};

export type ListingsContextType = {
  handlers: {
    setModalContent: SetModalContent;
  } & ListingActionHandlers;
};

export const ListingsContext = createContext<ListingsContextType>(
  {} as ListingsContextType
);

export const ListingsContextProvider = ListingsContext.Provider;

export const useListingsContext = () => useContext(ListingsContext);
